export default "__VITE_ASSET__B0qwo2hL__"